import axios from "axios";
import eventEmitter from "./eventEmitter";

export const GETREQUEST = async (URL, token, showLoader = true) => {
    const headers = { Authorization: "Bearer " + token }
    if (showLoader)
        eventEmitter.emit('showLoading', true);

    try {
        const response = await axios.get(URL, { headers });
        return { data: response.data };
    } catch (error) {
        return error.response ? { error: error.response.data } : { error: error.message };
    } finally {
        eventEmitter.emit('hideLoading', false);
    }
}

export const POSTREQUEST = async (URL, payload, token, showLoader = true) => {
    const headers = { Authorization: "Bearer " + token }
    if (showLoader)
        eventEmitter.emit('showLoading', true);

    try {
        const response = await axios.post(URL, payload, { headers });
        return { data: response.data };
    } catch (error) {
        return error.response ? { error: error.response.data } : { error: error.message };
    } finally {
        eventEmitter.emit('hideLoading', false);
    }
};

export const PATCHREQUEST = async (URL, payload, token, showLoader = true) => {
    const headers = { Authorization: "Bearer " + token }
    if (showLoader)
        eventEmitter.emit('showLoading', true);

    try {
        const response = await axios.patch(URL, payload, { headers });
        return { data: response.data };
    } catch (error) {
        return error.response ? { error: error.response.data } : { error: error.message };
    } finally {
        eventEmitter.emit('hideLoading', false);
    }
};

export const DELETEREQUEST = async (URL, token, showLoader = true) => {
    const headers = { Authorization: "Bearer " + token }
    if (showLoader)
        eventEmitter.emit('showLoading', true);

    try {
        const response = await axios.get(URL, { headers });
        return { data: response.data };
    } catch (error) {
        return error.response ? { error: error.response.data } : { error: error.message };
    } finally {
        eventEmitter.emit('hideLoading', false);
    }
}

export const LOGINPOSTREQUEST = async (URL, payload) => {
    eventEmitter.emit('showLoading', true);

    try {
        const response = await axios.post(URL, payload);
        return { data: response.data };
    } catch (error) {
        return error.response ? { error: error.response.data } : { error: error.message };
    } finally {
        eventEmitter.emit('hideLoading', false);
    }
};
